/**
 * @format
 */
import { api } from '@/scripts/api';

export const MDFFilterService = {
    getFundPoolCounts(accountId, queryParams) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-pools/filter/account/${accountId}?quickFilter=${queryParams}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getAvailableVendorCounts(accountId, queryParams) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/mdf/${accountId}/available-funds/filters?quickFilters=${queryParams}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getManagementCounts(
        { accountId, isClient },
        { vendors, status, requestMakers, activities, managers }
    ) {
        return new Promise((resolve, reject) => {
            const quickfilter = [];
            if (vendors.length) {
                quickfilter.push(`"vendors":${JSON.stringify(vendors)}`);
            }
            if (status.length) {
                quickfilter.push(`"status":${JSON.stringify(status)}`);
            }
            if (requestMakers.length) {
                quickfilter.push(`"requestMakers":${JSON.stringify(requestMakers)}`);
            }
            if (activities.length) {
                quickfilter.push(`"activityTypes":${JSON.stringify(activities)}`);
            }
            if (managers.length) {
                quickfilter.push(`"managers":${JSON.stringify(managers)}`);
            }
            let service = '';
            if (isClient) {
                service = `/ms/marketing-development-funds/v1/fund-requests/filter/client-account/${accountId}/requests`;
            } else {
                service = `/ms/marketing-development-funds/v1/mdf/filter/requests-partners/account/${accountId}`;
            }
            if (quickfilter.length) {
                service += `?quickFilter={${quickfilter.join(',')}}`;
            }
            api.get(service).then(resolve).catch(reject);
        });
    },
};
